import { removeWhitespace } from '@shared/helpers'
import { PHONE_COUNTRY_CODE } from '@ui-common/types'
import { getFieldError } from '@ui-common/utils/form'
import { FormTextInput } from '@ui-components/form/FormTextInput'
import { InputFieldPrefix } from '@ui-components/global/CommonStyling'
import { FocusEvent } from 'react'
import { useFormContext, useFormState } from 'react-hook-form'
import * as R from 'remeda'
import { styled } from 'styled-components'

const CenteredPrefix = styled(InputFieldPrefix)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 12px;
  gap: 10px;
`

export const FinnishPhoneNumberInput = ({
  label,
  description,
  phoneNumberField,
}: {
  label: string
  description: string
  phoneNumberField: string
}) => {
  const { register, setValue } = useFormContext()
  const { errors } = useFormState({ name: [phoneNumberField] })

  const cleanUpPhoneNumber = (event: FocusEvent<HTMLInputElement>) => {
    const value = event.target.value.toString()
    if (value && value.length > 0) {
      const newValue = R.pipe(value, removeWhitespace)
      setValue(phoneNumberField, newValue, { shouldValidate: true })
    }
  }

  return (
    <FormTextInput
      type="tel"
      autoComplete="tel-national"
      inputMode="tel"
      required={true}
      renderPrefix={() => <CenteredPrefix weight="regular">{PHONE_COUNTRY_CODE}</CenteredPrefix>}
      label={label}
      description={description}
      error={getFieldError(errors, phoneNumberField)?.message}
      {...register(phoneNumberField, { onBlur: (event) => cleanUpPhoneNumber(event) })}
    />
  )
}
